export const KIERSTEN_GUIDE_PATHS = [
  '/guides',
  '/guides/flying-with-a-baby',
  '/guides/disney-packing-checklist',
  '/guides/beach-with-a-baby',
  '/guides/beach-with-a-toddler',
] as const;

export function isKierstenGuidePath(pathname: string): boolean {
  return (
    pathname === '/guides' ||
    KIERSTEN_GUIDE_PATHS.some((path) => path !== '/guides' && pathname === path)
  );
}

export type GuideAccessDecision = 'loading' | 'redirect' | 'allow';

export function resolveGuideAccess(isLoaded: boolean, isSignedIn: boolean): GuideAccessDecision {
  if (!isLoaded) return 'loading';
  if (!isSignedIn) return 'redirect';
  return 'allow';
}

export function buildGuideSignupRedirect(pathname: string, search = ''): string {
  const next = `${pathname}${search}`;
  return `/signup?next=${encodeURIComponent(next)}`;
}
